import GetStarted from './routes/GetStarted'
import React, { useEffect, useState } from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { auth } from './firebase.js'
import Layout from './components/Layout.js'
import ChatPage from './routes/ChatPage.js'
import AdminPage from './routes/AdminPage.js'
import UpdatePrompts from './routes/UpdatePrompts.js'
import ListPrompts from './routes/ListPrompts.js'
import NotFoundPage from './routes/NotFoundPage.js'
import { CircularProgress, Box } from '@mui/material'

function App () {
  const [loading, setLoading] = useState(true)
  const [user, setUser] = useState(null)

  // Platzhalter
  const isAdmin = true

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((authUser) => {
      if (authUser) {
        authUser.getIdTokenResult().then((idTokenResult) => {
          authUser.admin = idTokenResult.claims.admin
        })
        // If user is authenticated, set the user state
        setUser(authUser)
        setLoading(false)
      } else {
        // If user is not authenticated, set user state to null
        setUser(null)
        setLoading(false)
      }
    })
    return () => unsubscribe()
  }, [])

  if (loading) {
    // Render a loading indicator while waiting for auth state
    return <>
    <Box sx={{ height: '100vh', margin: 'auto', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <CircularProgress></CircularProgress>
    </Box>
    </>
  }
  if (user) {
    return (
      <Router>
        <div className="App">
          <Layout displayName={auth.currentUser.email}>
            <Routes>
              <Route path="/" element={ <ChatPage/>} />
              <Route path="/admin" element={isAdmin ? <Navigate to="/" replace /> : <AdminPage></AdminPage>}></Route>
              <Route path="/update" element={isAdmin ? <Navigate to="/" replace /> : <UpdatePrompts></UpdatePrompts>}></Route>
              <Route path="/list" element={isAdmin ? <Navigate to="/" replace /> : <ListPrompts></ListPrompts>} ></Route>
              <Route path="/*" element={ <NotFoundPage></NotFoundPage>} ></Route>
            </Routes>
          </Layout>
        </div>
      </Router>
    )
  }

  return (
    <Router>
      <div className="App">
          <Routes>
            <Route path="/" element={<GetStarted/>} />
            <Route path="/*" element={<Navigate to="/" replace />} />
          </Routes>
      </div>
    </Router>
  )
}

export default App
